import angular from 'angular';
import { IPagamentoConfirmModal } from '../../../models/pagamentoponto.model';

export class PagamentosPontoConfirmModalService {
    static $inject = ['$uibModal'];

    constructor(public $uibModal: ng.ui.bootstrap.IModalService) {}

    open(entity: IPagamentoConfirmModal) {
        return this.$uibModal.open({
            template: require('html-loader!./pagamentos-confirm.modal.html'),
            controller: 'PagamentosPontoConfirmModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                entity: () => angular.copy(entity)
            }
        });
    }
}
